/* In By Dark cart-add log (2026-10-26). Native only: writes Shopify cart attributes
   (no external endpoint, no tokens). Data appears on abandoned checkouts + orders
   ("Additional details" / note_attributes). Undo: remove the <script> tag in layout/theme.liquid. */
(function () {
  if (window.__ibdCartLog) return; window.__ibdCartLog = 1;
  var KEY = 'ibd_touch_v1', MAX = 15;
  var origFetch = window.fetch.bind(window);
  function nowCT() {
    try { return new Date().toLocaleString('sv-SE', { timeZone: 'America/Chicago' }) + ' CT'; } catch (e) { return new Date().toISOString(); }
  }
  // First touch (30 days) + last touch, recorded on every page view.
  var touch = {};
  try { touch = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) {}
  var q = new URLSearchParams(location.search), utm = [];
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { if (q.get(k)) utm.push(k.replace('utm_', '') + '=' + q.get(k)); });
  if (q.get('fbclid')) utm.push('fbclid=y');
  var thisHit = { t: nowCT(), page: location.pathname, utm: utm.join('&'), ref: document.referrer ? document.referrer.split('?')[0].slice(0, 120) : '' };
  var external = !document.referrer || document.referrer.indexOf(location.host) === -1;
  if (!touch.first || (Date.now() - (touch.firstMs || 0)) > 30 * 864e5) { touch.first = thisHit; touch.firstMs = Date.now(); }
  if (external || utm.length) touch.last = thisHit;
  try { localStorage.setItem(KEY, JSON.stringify(touch)); } catch (e) {}

  function fmt(h) { return h ? [h.t, h.page, h.utm || '-', h.ref || 'direct'].join(' | ') : ''; }
  function parseBody(b) {
    var out = [];
    try {
      if (b instanceof FormData || b instanceof URLSearchParams) { var id = b.get('id'); if (id) out.push({ id: +id, qty: +(b.get('quantity') || 1) }); }
      else if (typeof b === 'string') {
        if (b.trim().charAt(0) === '{') { var j = JSON.parse(b); (j.items || [j]).forEach(function (i) { if (i.id) out.push({ id: +i.id, qty: +(i.quantity || 1) }); }); }
        else { var u = new URLSearchParams(b); if (u.get('id')) out.push({ id: +u.get('id'), qty: +(u.get('quantity') || 1) }); }
      }
    } catch (e) {}
    return out;
  }
  var busy = Promise.resolve();
  function record(adds) {
    busy = busy.then(function () {
      return origFetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
        var a = cart.attributes || {}, log = (a.ibd_adds || '').split('\n').filter(Boolean);
        adds.forEach(function (ad) {
          var li = (cart.items || []).filter(function (i) { return i.variant_id === ad.id; })[0];
          var name = li ? (li.product_title + ' | ' + (li.variant_title || '')) : ('variant ' + ad.id);
          log.push(nowCT() + ' | ' + name + ' | qty ' + ad.qty + ' | v' + ad.id + ' | on ' + location.pathname);
        });
        log = log.slice(-MAX);
        var attrs = { ibd_adds: log.join('\n'), ibd_first_touch: fmt(touch.first), ibd_last_touch: fmt(touch.last || touch.first) };
        if (!a.ibd_first_add) attrs.ibd_first_add = nowCT();
        return origFetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) });
      });
    }).catch(function () {});
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (/\/cart\/add(\.js|\.json)?(\?|$)/.test(url) && (!init || (init.method || 'GET').toUpperCase() === 'POST')) {
      var adds = parseBody(init && init.body);
      p.then(function (r) { if (r.ok && adds.length) setTimeout(function () { record(adds); }, 300); }).catch(function () {});
    }
    return p;
  };
})();
